import { Avatar, Box, Typography } from '@mui/material';
import logo from '../images/sporttia-icon.svg';

type LogoHeadingProps = {
    caption: string;
};

export default function LogoHeading({ caption }: LogoHeadingProps) {
    return (
        <Box display="flex" flexDirection="column" alignItems="center">
            <Avatar
                sx={{
                    width: 120,
                    height: 120,
                    marginBottom: 2,
                }}
            >
                <img
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                    }}
                    src={logo}
                    alt="Sporttia logo"
                />
            </Avatar>
            <Typography variant="h5">{caption}</Typography>
        </Box>
    );
}
